export default __webpack_public_path__ + "static/media/leandro.a9460b81.jpg";